import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeRequests: 0,
  isLoading: false,
  overlayLoading: false,
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.activeRequests += 1;
      state.isLoading = true;
    },

    stopLoading: (state) => {
      state.activeRequests = Math.max(0, state.activeRequests - 1);
      state.isLoading = state.activeRequests > 0;
    },

    showOverlay: (state) => {
      state.overlayLoading = true;
    },

    hideOverlay: (state) => {
      state.overlayLoading = false;
    },
  },
});

export const { startLoading, stopLoading, showOverlay, hideOverlay } = loaderSlice.actions;

export default loaderSlice.reducer;
